export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1783987597078-84d5ac51d518?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxlbXB0eSUyMHJldGFpbCUyMHNwYWNlJTIwY29tbWVyY2lhbCUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJhbCUyMG1lYXN1cmluZ3xlbnwwfHx8fDE3OTE5OTc2OTl8MA&ixlib=rb-4.1.0&q=85",
  mall: "https://images.unsplash.com/photo-1761333482894-700fc6aebd47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHxfHxlbXB0eSUyMHJldGFpbCUyMHNwYWNlJTIwY29tbWVyY2lhbCUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJhbCUyMG1lYXN1cmluZ3xlbnwwfHx8fDE3OTE5OTc2OTl8MA&ixlib=rb-4.1.0&q=85",
  blueprint: "https://images.unsplash.com/photo-1603901622056-0a5bee231395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3R1cmFsJTIwZmxvb3IlMjBwbGFuJTIwZHJhZnQlMjB0ZWNobmljYWwlMjBkcmF3aW5nfGVufDB8fHx8MTc5MTk5NzcwNnww&ixlib=rb-4.1.0&q=85",
  floorplan: "https://images.unsplash.com/photo-1721244653721-bc681b2dfd27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwZmxvb3IlMjBwbGFuJTIwZHJhZnQlMjB0ZWNobmljYWwlMjBkcmF3aW5nfGVufDB8fHx8MTc5MTk5NzcwNnww&ixlib=rb-4.1.0&q=85",
  storefront: "https://images.unsplash.com/photo-1782545647904-55d6316c0161?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxzdXJ2ZXlpbmclMjB0cmlwb2QlMjBsYXNlciUyMG1lYXN1cmluZyUyMGNvbW1lcmNpYWwlMjBidWlsZGluZ3xlbnwwfHx8fDE3OTE5OTc3MDZ8MA&ixlib=rb-4.1.0&q=85",
  luxury: "https://images.unsplash.com/photo-1688439227385-83245055e376?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwYmx1ZXByaW50JTIwZHJhZnQlMjBDQUQlMjBkcmF3aW5nJTIwM0QlMjBzY2FuJTIwcmV0YWlsJTIwc3RvcmUlMjBpbnRlcmlvcnxlbnwwfHx8MTc5MTk5NzY5OXww&ixlib=rb-4.1.0&q=85",
};

export const STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];

export const TERRITORIES = ["PR", "GUAM"];

export const CONTACT_EMAIL = "wjohnson@global-dimension.net";
export const CONTACT_PHONE = "(773) 857-7770";
export const MATTERPORT_TOUR_URL = "https://my.matterport.com/show/?m=DS69mHHbRJ2&mls=1&brand=0";

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Send us your site",
    body: "Share the address, approximate square footage, services you need, and your deadline through our quote form or by email.",
  },
  {
    n: "02",
    title: "Get your quote",
    body: "We review the project and send a quote with pricing and available dates — typically within one business day.",
  },
  {
    n: "03",
    title: "Schedule the visit",
    body: "We coordinate access with you, the landlord, or the property manager. Need a certificate of insurance? We can provide one on request.",
  },
  {
    n: "04",
    title: "We measure on site",
    body: "We travel to the space and measure it in person, along with a Matterport scan if you ordered one.",
  },
  {
    n: "05",
    title: "Receive your files",
    body: "Your DWG and PDF drawings arrive within 7 to 10 days of the site visit. Matterport tours are shared by link, ready for your team to explore.",
  },
];
